import React from "react";

export default function IsOverdueIcon(props) {
  return (
    <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9 0L0 9L9 18L18 9L9 0ZM8.25 4.5H9.75V10.5H8.25V4.5ZM9 13.6875C8.4825 13.6875 8.0625 13.2675 8.0625 12.75C8.0625 12.2325 8.4825 11.8125 9 11.8125C9.5175 11.8125 9.9375 12.2325 9.9375 12.75C9.9375 13.2675 9.5175 13.6875 9 13.6875Z"
        fill="#CA367E"
      />
    </svg>
  );
}
